import { useState } from "react";
import { ThumbsDown, ThumbsUp } from "lucide-react";
import { axiosInstance } from "@/App";

export const AnswerFeedback = ({ question, answer, testId }) => {
  const [sent, setSent] = useState(null);
  const send = (helpful) => {
    setSent(helpful);
    axiosInstance.post("/help/feedback", { question, answer, helpful }).catch(() => {});
  };
  if (sent !== null) return <div className="mt-1 text-[11px] text-gray-400" data-testid={`${testId}-thanks`}>{sent ? "Thanks!" : "Thanks — an admin will teach me the right answer."}</div>;
  return (
    <div className="mt-1 flex gap-2 text-gray-400" data-testid={testId}>
      <button type="button" onClick={() => send(true)} className="hover:text-emerald-600" aria-label="Helpful" data-testid={`${testId}-up`}><ThumbsUp className="h-3.5 w-3.5" /></button>
      <button type="button" onClick={() => send(false)} className="hover:text-red-600" aria-label="Not helpful" data-testid={`${testId}-down`}><ThumbsDown className="h-3.5 w-3.5" /></button>
    </div>
  );
};
